import * as React from "react";
import { useAsync } from "react-async-hook";
import querystring from "querystring";
import {
  withTheme,
  AppBar,
  Toolbar,
  BottomNavigation,
  BottomNavigationAction,
  IconButton,
  InputBase,
  Typography,
  withStyles,
  Badge,
  InputAdornment,
  Button
} from "@material-ui/core";
import { SDKContext } from "../../../context/SDKContext";
import { WhiteLabelContext } from "../../../context/WhiteLabelContext";
import label from "../../../framework/whiteLabel";
// import logo from "../../../assets/ff.png";
import {
  // Home,
  Favorite,
  Search,
  ShoppingCart,
  Clear,
  CloseRounded,
  Home,
  Cached,
  FileCopy
} from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import { styles } from "./style";
import s from "./ffAppBar.module.css";
import FFAppBarMenu from "../../FFAppBarMenu";
import ShoppingCartDialog from "../../ShoppingCartDialog";
import Favorites from "../../Favorites";
import GlobalContext from "../../../context/globalContext";
// import OrdersDialog from "../../OrdersDialog";
import SaveDialog from "../../SaveDialog";
import Account from "../../Account";
import ReorderDialog from "../../ReorderDialog";
import TutorialDialog from "../../TutorialDialog";
import NewUserDeliveryLocationDialog from "../../NewUserDeliveryLocationDialog";
import shareDialogBackground from "../../../assets/share-dialog-bg.png";

class FFAppBar extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      callout: -350,
      disableSearchBar: false,
      newSearch: false
    };
  }

  componentWillUnmount() {
    this.context.global.submitShoppingCartChanges();
    //WTF
  }

  searchInput = React.createRef();

  async handleSearchChange(ev) {
    this.setState({ newSearch: true });

    this.context.global.setGlobalState(
      "searchBarTextValue",
      ev.target.value ? ev.target.value : ""
    );

    if (ev.target.value.length === 0) {
      this.context.global.setGlobalState("searchResults", null);
      setTimeout(
        () =>
          this.context.global.setGlobalState(
            "bottomNavigationValue",
            "homeDialogState"
          ),
        5000
      );
    } else {
      // this.context.global.getSearchResults(ev.target.value);
    }
  }

  handleKeyPress = event => {
    if (event.key === "Enter") {
      this.submitSearch();
    }
  };

  submitSearch = () => {
    const { searchBarTextValue } = this.context.global.data;
    const { newSearch } = this.state;
    if (searchBarTextValue.length !== 0 && newSearch) {
      window.scrollTo(0, 0);
      this.context.global.getSearchResults(searchBarTextValue);
      this.setState({ newSearch: false });
    } else {
    }
  };

  toggleBottomNavigation = (event, value) => {
    this.context.global.setGlobalState("bottomNavigationValue", value);
    // this.context.global.setGlobalState(value, true);
    this.context.global.handleDashboardActions("FORWARD", value);
    this.context.global.setGlobalState(
      "popUpLocationInstanceDialogCallout",
      -350
    );
    // this.setState({ callout: -350 });
  };

  openShoppingCart = direction => {
    this.context.global.getPopUpLocationInstanceCheck();
    this.context.global.setGlobalState(
      "shoppingCartDialogDirection",
      direction
    );
    // this.context.global.setGlobalState("shoppingCartDialogState", true);
    this.context.global.handleDashboardActions(
      "FORWARD",
      "shoppingCartDialogState"
    );
  };

  render() {
    const { classes, theme } = this.props;
    const { disableSearchBar } = this.state;
    const { global } = this.context;
    const {
      bottomNavigationValue,
      searchBarTextValue,
      popUpLocationInstanceDialogCallout,
    } = global.data;

    return (
      <React.Fragment>
        <AppBar position="static" style={{ position: "fixed", zIndex: 90001 }}>
          <Toolbar style={{ flexDirection: "row", minHeight: 0 }}>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              aria-label="Open drawer"
              aria-haspopup="true"
              onClick={() => {
                // this.context.global.setGlobalState("appMenuDialogState", true);
                this.context.global.handleDashboardActions(
                  "FORWARD",
                  "appMenuDialogState"
                );
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              className={classes.title}
              variant="body1"
              color="inherit"
              noWrap
            >
              {label.title}
            </Typography>
            {!disableSearchBar ? (
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <Search />
                </div>

                <InputBase
                  id={"searchInput"}
                  inputRef={this.searchInput}
                  placeholder="Search…"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput
                  }}
                  value={searchBarTextValue}
                  onChange={this.handleSearchChange.bind(this)}
                  onFocus={() => {
                    this.context.global.setGlobalState(
                      "bottomNavigationValue",
                      "searchDialogState"
                    );
                  }}
                  onBlur={this.submitSearch}
                  onKeyPress={this.handleKeyPress}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: "whitesmoke", padding: 0 }}
                        onClick={() => {
                          this.handleSearchChange({ target: { value: "" } });
                        }}
                      >
                        {searchBarTextValue ? <Clear /> : null}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
            ) : null}
            <div className={classes.sectionMobile}>
              <IconButton
                aria-haspopup="true"
                onClick={() => this.openShoppingCart("down")}
                color="inherit"
              >
                <Badge
                  badgeContent={
                    global.data.shoppingCart
                      ? global.data.shoppingCart.cartDetails.numberOfItems
                      : 0
                  }
                  color="secondary"
                  style={{ zIndex: 90001 }}
                >
                  {!disableSearchBar ? <ShoppingCart /> : null}
                </Badge>
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>

        {this.props.children}

        <FFAppBarMenu handleSearchChange={this.handleSearchChange.bind(this)} />
        {/* <OrdersDialog history={this.props.history} /> */}
        <Account history={this.props.history} />
        <ShoppingCartDialog history={this.props.history} />
        <SaveDialog />
        <Favorites />
        <ReorderDialog />
        <TutorialDialog />
        <NewUserDeliveryLocationDialog />
        {!global.data.shoppingCart ? null : (
          <div
            className={s.calloutContainer}
            style={{ bottom: popUpLocationInstanceDialogCallout }}
          >
            <CloseRounded
              style={{ color: theme.palette.primary.main }}
              className={s.dialogCloseButton}
              onClick={() => {
                this.context.global.setGlobalState(
                  "popUpLocationInstanceDialogCallout",
                  -350
                );
                // this.setState({ callout: -350 });
                this.context.global.setGlobalState(
                  "popUpLocationInstanceDialogState",
                  false
                );
                this.context.global.setGlobalState(
                  "bottomNavigationValue",
                  "homeDialogState"
                );
              }}
            />
            <ReferralPanelContent />
          </div>
        )}
        <BottomNavigation
          value={bottomNavigationValue}
          onChange={this.toggleBottomNavigation}
          // classes={{
          //   root: classes.bottomNavigationRoot
          // }}
          // style={isIOS ? {paddingBottom: '200px', height: 200}: null}
        >
          <BottomNavigationAction
            label="Reorder"
            value="reorderDialogState"
            icon={<Cached />}
          />
          <BottomNavigationAction
            label="Favorites"
            value="favoritesDialogState"
            icon={<Favorite />}
          />
          <BottomNavigationAction
            value="popUpLocationInstanceDialogState"
            icon={
              <img
                style={{ paddingBottom: 15 }}
                src={label.logoUrl}
                width={25}
                alt={""}
              />
            }
            onClick={() => {
              this.context.global.setGlobalState(
                "popUpLocationInstanceDialogCallout",
                popUpLocationInstanceDialogCallout > 0 ? -350 : 50
              );
              // this.setState({
              //   callout: callout > 0 ? -350 : 50
              // });
              this.context.global.setGlobalState(
                "bottomNavigationValue",
                "homeDialogState"
              );
            }}
          />
          <BottomNavigationAction
            label="Search"
            value="searchDialogState"
            icon={<Search />}
            onClick={() => {
              this.searchInput.current.focus();
            }}
          />
          <BottomNavigationAction
            label="Home"
            value="home"
            onClick={() => {
              window.scrollTo(0, 0);
              setTimeout(
                () =>
                  this.context.global.setGlobalState(
                    "bottomNavigationValue",
                    "homeDialogState"
                  ),
                2000
              );
            }}
            icon={<Home />}
          />
        </BottomNavigation>
      </React.Fragment>
    );
  }
}

export default withTheme()(withStyles(styles)(FFAppBar));

function ReferralPanelContent() {
  const { sdk } = React.useContext(SDKContext);
  const { whiteLabel } = React.useContext(WhiteLabelContext);

  const referralCodeResult = useAsync(() => sdk.getReferralCode(), []);

  function renderNoReferralCodeContent() {
    return (
      <div className={s.referralCodeEmptyContainer}>
        <div className={s.referralHeading}>No referral codes available</div>
        <div className={s.referralCodeEmptySubText}>
          Please check again later!
        </div>
      </div>
    );
  }

  if (referralCodeResult.loading) {
    return renderNoReferralCodeContent();
  }

  if (referralCodeResult.error) {
    return renderNoReferralCodeContent();
  }

  if (referralCodeResult.result === undefined) {
    return null;
  }

  if (referralCodeResult.result.error) {
    return renderNoReferralCodeContent();
  }

  const moneyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const percentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  let referralCode = referralCodeResult.result.data;
  referralCode.code = referralCode.code.toUpperCase();
  const referralTemplate = referralCode.referralTemplate;
  const subject = `Check out the ${whiteLabel.title} App!`;
  const formatter =
    referralTemplate.refereeAmountKind === "FIXED"
      ? moneyFormatter
      : percentFormatter;
  const body = `Try the ${whiteLabel.title} App and get ${formatter.format(
    referralTemplate.refereeAmount / 100
  )} off your first order when you use my code! ${referralCode.code} at ${
    referralTemplate.messageUrl
  }`;

  return (
    <>
      <div
        className={s.referralPanelHero}
        style={{
          backgroundImage: `linear-gradient(-90deg, white, rgba(255, 255, 255, 0.8)), url(${shareDialogBackground})`
        }}
      >
        {referralTemplate.headlineText}
      </div>
      <div className={s.referralPanelContent}>
        <div className={s.referralHeading}>Share your code</div>
        <div className={s.referralInputs}>
          <button
            type="button"
            onClick={async () => {
              try {
                const result = await navigator.permissions.query({
                  name: "clipboard-write"
                });
                if (result.state === "granted" || result.state === "prompt") {
                  await navigator.clipboard.writeText(referralCode.code);
                }
              } catch (e) {}
            }}
            className={s.referralCodeContainerButton}
          >
            <div className={s.referralCodeContainer}>
              <div className={s.referralCode}>{referralCode.code}</div>
              <FileCopy />
            </div>
          </button>
          <div className={s.referralButtonContainer}>
            <Button
              as="a"
              href={`sms:+1&${querystring.stringify({ body })}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                // Ugh. Match outlined button
                paddingLeft: 16,
                paddingRight: 16
              }}
            >
              Text Friends
            </Button>
            <Button
              variant="outlined"
              as="a"
              href={`mailto:?${querystring.stringify({ subject, body })}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Email Friends
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
